const isLoggingEnabled = process.env.REACT_APP_ENABLE_LOGS === 'true';

const log = (...args) => {
  if (isLoggingEnabled) {
    console.log(...args);
  }
};

export default log;